import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from '@sentry/react'
import App from './App'
import TooltipLayer from './components/TooltipLayer'
import './index.css'

// Only register service worker and PWA features on /dashboard
const isDashboard = window.location.pathname.startsWith('/dashboard');

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (isDashboard) {
      // Register service worker with /dashboard scope
      navigator.serviceWorker.register('/service-worker.js', { scope: '/dashboard' })
        .then((registration) => {
          console.log('✅ Service Worker registered for dashboard:', registration.scope);
          
          // Check for updates periodically
          setInterval(() => {
            registration.update();
          }, 60000); // Check every minute
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error);
        });
    } else {
      // On non-dashboard pages, unregister any service workers with root scope
      // This cleans up the old behavior
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          // Only unregister if it's NOT scoped to dashboard
          if (registration.scope.endsWith('/') && !registration.scope.includes('/dashboard')) {
            registration.unregister().then(() => {
              console.log('🧹 Cleaned up old root-scoped service worker');
            });
          }
        }
      });
    }
  });
}

// Handle PWA install prompt - ONLY on dashboard
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  // Only allow PWA install from dashboard
  if (!window.location.pathname.startsWith('/dashboard')) {
    console.log('🚫 PWA install blocked - not on dashboard');
    return; // Don't capture the prompt on non-dashboard pages
  }
  
  console.log('💾 PWA install prompt fired on dashboard');
  e.preventDefault();
  deferredPrompt = e;
  // Store it globally so the dashboard can access it
  window.deferredPrompt = deferredPrompt;
});

// Track if app was installed
window.addEventListener('appinstalled', () => {
  console.log('✅ PWA installed successfully!');
  deferredPrompt = null;
  window.deferredPrompt = null;
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<p>Something went wrong</p>} showDialog>
      <App />
      {/* One app-wide hover tooltip for every button (data-tip / aria-label / title). */}
      <TooltipLayer />
    </ErrorBoundary>
  </React.StrictMode>,
)